import * as React from "react";
const SvgFiRrFaceMask = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-mask_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12c0 1.11.152 2.211.452 3.271a.995.995 0 0 0 1.234.69 1 1 0 0 0 .69-1.233A10 10 0 0 1 2 11.999c0-.243.019-.481.036-.719L4 13.392v4.64c0 1.724.9 3.349 2.349 4.24 1.276.788 3.292 1.727 5.651 1.727s4.375-.938 5.65-1.726c1.449-.893 2.35-2.518 2.35-4.241v-4.634l1.966-2.074c.015.224.034.447.034.675 0 .926-.126 1.844-.376 2.729a.999.999 0 1 0 1.924.542c.3-1.061.452-2.161.452-3.271C24 5.383 18.617 0 12 0m6 18.033a3 3 0 0 1-1.399 2.539C15.545 21.223 13.889 22 12 22s-3.545-.776-4.602-1.429A2.99 2.99 0 0 1 6 18.033V14h12zM18.57 12H5.435L2.513 8.857C3.835 4.88 7.584 2 12 2s8.197 2.902 9.504 6.905zm-7.589-5.196a1 1 0 0 1-.784 1.177c-1.161.232-2.356.859-3.553 1.865a1 1 0 0 1-1.287-1.531C6.814 7.09 8.31 6.319 9.804 6.02a.996.996 0 0 1 1.177.784m7.663 1.511a1 1 0 0 1-1.287 1.531c-1.196-1.006-2.392-1.633-3.553-1.865a1 1 0 0 1-.784-1.177.995.995 0 0 1 1.177-.784c1.494.299 2.99 1.07 4.447 2.295"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-mask_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceMask;
